import { useSearchParams } from "react-router-dom";
// types
// import { type IsDisabledFilter, type IsConfirmedFilter } from "../lib/types";
type IsDisabledFilter = any;
type IsConfirmedFilter = any;
// constants
const IS_DISABLED_DEFAULT_VALUE = "is_disabled:eq:true|false";
const IS_CONFIRMED_DEFAULT_VALUE = "is_confirmed:eq:true|false";
const FROM_DEFAULT_VALUE = "";
const TO_DEFAULT_VALUE = "";
const BUSINESS_STATUS_DEFAULT_VALUE = "status:eq:accepted|denied|pending";
const JOBS_STATUS_DEFAULT_VALUE = "status:eq:accepted|rejected|pending";
const CITY_FILTER_ID = "";
const USER_FILTER_ID = "";
const CATEGORY_FILTER_ID = "";
const JOIN_REQUEST_STATUS = "is_complete:eq:false";
const SERVICE_TYPE_DEFAULT_VALUE = "";
const TRANSACTION_TYPE_DEFAULT_VALUE = "type:eq:credit|debit";
const NOTIFICATION_STATUS_DEFAULT_VALUE = "status:eq:accepted|rejected|pending";
const PURCHASE_REQUEST_STATUS_DEFAULT_VALUE = "status:eq:accepted|rejected|pending";

const useFilterParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isDisabled =
    searchParams.get("isDisabled") || IS_DISABLED_DEFAULT_VALUE;

  const isConfirmed =
    searchParams.get("isConfirmed") || IS_CONFIRMED_DEFAULT_VALUE;

  const from = searchParams.get("from") || FROM_DEFAULT_VALUE;
  const to = searchParams.get("to") || TO_DEFAULT_VALUE;

  const businessStatus =
    searchParams.get("business_status") || BUSINESS_STATUS_DEFAULT_VALUE;
  const jobsStatus =
    searchParams.get("jobs_status") || JOBS_STATUS_DEFAULT_VALUE;

  const cityId = searchParams.get("city_id") || CITY_FILTER_ID;
  const userId = searchParams.get("user_id") || USER_FILTER_ID;
  const categoryId = searchParams.get("category_id") || CATEGORY_FILTER_ID;
  const joinRequestStatus =
    searchParams.get("join_request_status") || JOIN_REQUEST_STATUS;

  const serviceType =
    searchParams.get("service_type") || SERVICE_TYPE_DEFAULT_VALUE;

  const transactionType =
    searchParams.get("transaction_type") || TRANSACTION_TYPE_DEFAULT_VALUE;
  const notificationStatus =
    searchParams.get("notification_status") ||
    NOTIFICATION_STATUS_DEFAULT_VALUE;
  const purchaseRequestStatus =
    searchParams.get("purchase_request_status") ||
    PURCHASE_REQUEST_STATUS_DEFAULT_VALUE;

  const setIsDisabled = (value: IsDisabledFilter) => {
    searchParams.set("isDisabled", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setIsConfirmed = (value: IsConfirmedFilter) => {
    searchParams.set("isConfirmed", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setFrom = (value: string) => {
    searchParams.set("from", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setTo = (value: string) => {
    searchParams.set("to", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setBusinessStatus = (value: string) => {
    searchParams.set("business_status", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const setJobsStatus = (value: string) => {
    searchParams.set("jobs_status", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setCityId = (value: string) => {
    searchParams.set("city_id", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const setUserId = (value: string) => {
    searchParams.set("user_id", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setCategoryId = (value: string) => {
    searchParams.set("category_id", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const setJoinRequestStatus = (value: string) => {
    searchParams.set("join_request_status", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setServiceType = (value: string) => {
    searchParams.set("service_type", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setTransactionType = (value: string) => {
    searchParams.set("transaction_type", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const setNotificationStatus = (value: string) => {
    searchParams.set("notification_status", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const setPurchaseRequestStatus = (value: string) => {
    searchParams.set("purchase_request_status", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const getFilter = (key: string): string => {
    return searchParams.get(key) || "";
  };

  // Generic filter setter
  const setFilter = (key: string, value: string) => {
    searchParams.set(key, value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  return {
    isDisabled,
    setIsDisabled,
    isConfirmed,
    setIsConfirmed,
    from,
    setFrom,
    to,
    setTo,
    businessStatus,
    setBusinessStatus,
    jobsStatus,
    setJobsStatus,
    cityId,
    setCityId,
    categoryId,
    setCategoryId,
    userId,
    setUserId,
    joinRequestStatus,
    setJoinRequestStatus,
    serviceType,
    setServiceType,
    transactionType,
    setTransactionType,
    notificationStatus,
    setNotificationStatus,
    purchaseRequestStatus,
    setPurchaseRequestStatus,
    getFilter,
    setFilter,
  };
};

export default useFilterParams;
